import { render, staticRenderFns } from "./Bubblechart.vue?vue&type=template&id=2166a23b&"
import script from "./Bubblechart.vue?vue&type=script&lang=js&"
export * from "./Bubblechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports